/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */
'use strict';

var SoaModel = require('bunsen/models/SoaModel.js');
var Transaction = module.exports = SoaModel.extend({}, {
    STATUS_NEW: 'NEW',
    STATUS_NEGOTIATING: 'NEGOTIATING',
    STATUS_NOT_AVAILABLE: 'NOT_AVAILABLE',
    STATUS_PENDING: 'PENDING',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REFUNDED: 'REFUNDED',
    STATUS_CLOSED: 'CLOSED',
    TYPE_NEGOTIABLE: 'NEGOTIABLE',
    TYPE_NON_NEGOTIABLE: 'NON_NEGOTIABLE',
    TYPE_PRE_AUTH_NEGOTIATION: 'PRE_AUTH_NEGOTIATION',
    CANCELLATION_REASON_FRAUD: 'FRAUD',
    CANCELLATION_REASON_CANCELED_BEFORE_APPROVED: 'CANCELED_BEFORE_APPROVED',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_SHIPPING: 'BUYER_NOT_RESPONDING_SHIPPING',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_OFFER: 'BUYER_NOT_RESPONDING_OFFER',
    CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT: 'BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT',
    CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT: 'BUYER_PASSED_ON_OFFER_PRE_CHECKOUT',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION',
    ERROR_EXISTING_TRANSACTION: 'EXISTING_TRANSACTION',
    ERROR_DUPLICATE_ORDER: 'DUPLICATE_ORDER'
});

var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');
var _ = require('underscore');
var bunsen = require('bunsen/libraries/bunsen');
var Offers = require('bunsen/collections/ecomm/Offers');
var Offer = require('bunsen/models/ecomm/Offer');
var CurrencyConversionRateEvent = require('bunsen/models/ecomm/CurrencyConversionRateEvent');
var Item = require('bunsen/models/inventory/Item');
var Shipment = require('./Shipment');
var TransactionShipmentQuotes = require('bunsen/collections/ecomm/TransactionShipmentQuotes');
var Seller = require('bunsen/models/Seller');
var PaymentAuthorizations = require('bunsen/collections/ecomm/PaymentAuthorizations');
var PaymentAuthorization = require('bunsen/models/ecomm/PaymentAuthorization');
var Invoices = require('bunsen/collections/ecomm/Invoices');
var Disbursements = require('bunsen/collections/ecomm/Disbursements');
var Notes = require('bunsen/collections/Notes');
var Note = require('bunsen/models/Note');
var User = require('bunsen/models/identity/User');
var Anchor = require('bunsen/models/Anchor');
var ReturnPolicy = require('bunsen/models/identity/ReturnPolicy');
var Promotions = require('bunsen/collections/ecomm/Promotions');
var Price = require('bunsen/models/inventory/Price.es');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var Actions = require('bunsen/collections/ecomm/Actions');
var Refunds = require('bunsen/collections/ecomm/Refunds');
var InvoiceSummary = require('bunsen/models/ecomm/InvoiceSummary.es');
var simplyDeferred = require('simply-deferred');

// Mixins
var actionMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionActionMixin');
var documentAccessMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionDocumentAccessMixin');
var statusMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionStatusMixin');
var currencyMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionCurrencyMixin');
var shippingMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionShippingMixin');
var checkoutMixin = require('bunsen/models/mixins/ecomm/Transaction/transactionCheckoutMixin');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');

var root = typeof window === 'undefined' ? global : window;

function warn(prop) {

    Object.defineProperty(Transaction, 'STATUS_' + prop, {
        get: function () {
            console.warn('Attempting to access pre-N2.0 transaction status!', prop);
            return prop;
        }
    });
}

warn('SECURING_PAYMENT');
warn('AWAITING_MANUAL_REVIEW');
warn('PENDING_INVENTORY_CHECK');
warn('INVENTORY_CONFIRMED');

root.bunsen = root.bunsen || {};

// root.bunsen for console debugging
root.bunsen.Transaction = Transaction;

_.extend(Transaction.prototype, {
    idAttribute: "id",
    defaults: {
        buyer: {},
        offers: [],
        shipmentQuotes: [],
        notes: [],
        invoices: [],
        shipment: {},
        disbursements: []
    },
    initialize: function () {
        this.urlRoot = endpoints.transaction();
        this.url = Backbone.Model.prototype.url;
    },
    relations: function () {
        return [
            {
                type: Backbone.Many,
                key: 'offers',
                collectionType: Offers
            },
            {
                type: Backbone.One,
                key: 'currencyConversionRateEvent',
                relatedModel: CurrencyConversionRateEvent
            },
            {
                type: Backbone.One,
                key: 'displayMetadata',
                relatedModel: SoaModel.extend({
                    relations: [{
                        type: Backbone.One,
                        key: 'sla',
                        relatedModel: SoaModel
                    }]
                })
            },
            {
                type: Backbone.One,
                key: 'item',
                relatedModel: Item,
                saveJSONFields: ['id', 'apiType']
            },
            {
                type: Backbone.One,
                key: 'shipment',
                relatedModel: Shipment
            },
            {
                type: Backbone.Many,
                key: 'shipmentQuotes',
                collectionType: TransactionShipmentQuotes
            },
            {
                type: Backbone.One,
                key: 'buyer',
                relatedModel: User,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.One,
                key: 'seller',
                relatedModel: Seller,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.Many,
                key: 'paymentAuthorizations',
                collectionType: PaymentAuthorizations
            },
            {
                type: Backbone.Many,
                key: 'invoices',
                collectionType: Invoices
            },
            {
                type: Backbone.Many,
                key: 'disbursements',
                collectionType: Disbursements
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'supportRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'salesRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'shippingRep',
                relatedModel: User
            },
            {
                key: 'returnPolicy',
                relatedModel: ReturnPolicy,
                type: Backbone.One
            },
            {
                key: 'promotions',
                collectionType: Promotions,
                type: Backbone.Many
            },
            {
                key: 'actions',
                collectionType: Actions,
                type: Backbone.Many
            },
            {
                key: 'refunds',
                collectionType: Refunds,
                type: Backbone.Many
            },
            {
                key: 'summary',
                relatedModel: SoaModel.extend({
                    relations: [
                        {
                            key: 'availablePrices',
                            relatedModel: Price,
                            type: Backbone.Many
                        },
                        {
                            key: 'acceptedOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'balanceDueAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'settlingAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'itemPrice',
                            relatedModel : Price,
                            type : Backbone.One
                        },
                        {
                            key : 'checkoutPaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key : 'balanceDuePaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key: 'checkoutOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'totalCapturedAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key: 'invoiceSummary',
                            relatedModel: InvoiceSummary,
                            type: Backbone.One
                        }
                    ]
                }),
                type: Backbone.One
            }
        ];
    },
    parse: function (response) {
        var transaction;
        if (response.result) {
            transaction = response.result;
        } else {
            transaction = response;
        }
        return SoaModel.prototype.parse.call(this, transaction);
    },
    getCancellationReason: function () {
        return this.get('cancellationReason');
    },
    canMultipleQuantityBePurchased: function () {
        var item = this.get('item');
        return item && item.canMultipleQuantityBePurchased();
    },
    savePrivateOffers: function () {
        if (this.isNew()) {
            // for new transactions, the entire transaction is saved
            // compute adjustments must be called before saving a transaction
            return this.computeAdjustments().then(this.save.bind(this));
        } else {
            // if adding offer to an existing transaction, save the offer
            return simplyDeferred.when.apply(simplyDeferred,
                _(this.get('offers').filter(bunsen.callon('isNew'))).invoke('save'));
        }
    },
    /**
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newNote: function (newNoteOptions, additionalAnchors) {
        return this.get('notes').newNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * Returns a new note with type BUYER_SELLER,
     * and defaults the createdBy to have the role
     * "SELLER" and the id to be the transaction
     * seller id
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newBuyerSellerNote: function (newNoteOptions, additionalAnchors) {
        newNoteOptions = _.extend({ creatorId: this.get('seller.id') }, newNoteOptions || {});
        return this.get('notes').newBuyerSellerNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * @param {object} [noteOptions]
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        return this.addAndSaveNote(note, syncOptions);
    },
    /**
     * @param {Note} note
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addAndSaveNote: function (note, syncOptions) {
        console.assert(note instanceof Note, 'Note must be instance of note');
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },

    _getOptionsForNewNote: function (newNoteOptions, additionalAnchors) {
        var anchors;
        newNoteOptions = newNoteOptions || {};
        anchors = newNoteOptions.anchors || this._getDefaultNoteAnchors() || [];
        anchors = additionalAnchors ? anchors.concat(additionalAnchors) : anchors;
        return _.extend({ anchors: anchors }, newNoteOptions);
    },
    _getDefaultNoteAnchors: function () {
        return [{
            sourceId : this.get('id'),
            sourceType : Anchor.TYPE_TRANSACTION
        }, {
            sourceId: this.get('seller.id'),
            sourceType : Anchor.TYPE_SELLER
        }];
    },
    /**
     * used for OMT reloading after changes to sub models.
     */
    refetch: function () {
        var self = this;
        var actions = this.get('actions');

        // remove all actions before fetching to make sure stale actions are removed
        if (actions) {
            actions.reset();
        }

        this.trigger('refetching');
        return this.fetch({
            refetching: true
        }).always(function () {
            self.trigger('refetched');
        });
    }
}, actionMixin, documentAccessMixin, statusMixin, currencyMixin, shippingMixin, checkoutMixin, transitionMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Transaction.js
// module id = 20
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55